import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

import { IconSetService } from '@coreui/icons-angular';
import { freeSet } from '@coreui/icons';
import { filter } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { environment } from '../environments/environment';

@Component({
  // tslint:disable-next-line
  selector: 'body',
  template: '<router-outlet></router-outlet>',
  providers: [IconSetService],
})
export class AppComponent implements OnInit {
  constructor(
    private router: Router,
    public iconSet: IconSetService,
    private http: HttpClient
  ) {
    // iconSet singleton
    // alert("call Api")

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        window.scrollTo(0, 0); // ✅ Scrolls to top on route change
      }
    });
    
    iconSet.icons = { ...freeSet };

    if (environment.maintenanceMode) {
      this.router.navigate(['/maintenance']);
    }

  }

  ngOnInit() {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });

    this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd) // Filter to only NavigationEnd events
    ).subscribe(() => {
      if (environment.maintenanceMode && this.router.url !== '/maintenance') {
        this.router.navigate(['/maintenance']);
      }else{
        this.callApiOnNavigation();
      }
    });
    
  }

  getToken() {
    return localStorage.getItem("token")
  }

  SERVER = environment.SERVER;
  callApiOnNavigation() {
    if(this.getToken()){
      this.http.post(`${this.SERVER}auth/check_deactivated_user`, {}).subscribe(
        (response) => {
          // console.log('API call successful:', response);
          // Handle the response as needed
        },
        (error) => {
          // console.log("error", error)
          this.logout();
        }
      );
    }
  }

  

  private logout(): void {
    localStorage.clear();
    sessionStorage.clear();
    this.router.navigate(['/login-initial']);
  }
  
  

}
